import React from "react";
import { ConfigurationError } from "./ConfigurationError";

export const StartupGate = ({ config, children }) => config.valid
    ? children
    : <ConfigurationError errors={config.errors} />;